<template>
  <section class="our-portfolio-section ptb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="section-heading text-center mb-5">
            <h2>{{ $t('our_projects.portfolio.title') }}</h2>
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6 col-lg-4"
          v-for="(key, index) in projectKeys"
          :key="index"
        >
          <div class="portfolio-wrapper shadow-sm p-4 rounded text-center">
            <img
              :src="getImageUrl(index)"
              :alt="$t(`our_projects.portfolio.projects.${key}`)"
              class="img-fluid mb-3 rounded"
            />
            <h5 class="text-dark">{{ $t(`our_projects.portfolio.projects.${key}`) }}</h5>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const projectKeys = [
  'ai_valuation',
  'price_prediction',
  'district_analysis',
  'report_automation',
  'developer_api_integration',
  'investment_index'
]

const images = [
  new URL('@/assets/ai/1.jpg', import.meta.url).href,
  new URL('@/assets/ai/2.jpg', import.meta.url).href,
  new URL('@/assets/ai/3.jpg', import.meta.url).href,
  new URL('@/assets/ai/4.jpg', import.meta.url).href,
  new URL('@/assets/ai/5.jpg', import.meta.url).href,
  new URL('@/assets/ai/6.jpg', import.meta.url).href
]

const getImageUrl = (index) => images[index]
</script>
